var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"qairn-generator-header"},[_c('h1',{staticClass:"qairn-generator-heading"},[_vm._v("JSON Generator for Qairn")]),_vm._v(" "),_c('a',{attrs:{"href":"./index.html"}},[_c('img',{attrs:{"src":"src/assets/qairn-logo.svg","width":"192px","alt":"Qairn logo"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7919f4ae","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 171
// module chunks = 0